import { svgCircleConfiguration } from '../svg/SvgCircle/configurations/SvgCircle.configuration.js';

import { containerConfiguration } from './Container/configurations/Container.configuration.js';
import { lineConfiguration } from './Line/configurations/Line.configuration.js';
import { rectConfiguration } from './Rect/configurations/Rect.configuration.js';
import { svgPolygonConfiguration } from './SvgPolygon/configurations/SvgPolygon.configuration.js';
import { svgRectConfiguration } from './SvgRect/configurations/SvgRect.configuration.js';
import { textConfiguration } from './Text/configurations/Text.configuration.js';
import { ISvgConfiguration } from './ISvgConfiguration.js';
/* [Component: import] */
/* [ChartComponent: import] */

export const svgConfiguration: ISvgConfiguration = {
	svgCircle: svgCircleConfiguration,
	svgRect: svgRectConfiguration,
	svgPolygon: svgPolygonConfiguration,
	container: containerConfiguration,
	rect: rectConfiguration,
	line: lineConfiguration,
	text: textConfiguration,
	/* [Component: interface] */
	/* [ChartComponent: interface] */
};
